import {
	PAGE_FILE_RESET_MESSAGE,
	PAGE_FILES_FETCH_REQUEST,
	PAGE_FILES_FETCH_FAILURE,
	PAGE_FILES_FETCH_SUCCESS,
	PAGE_FILE_CREATE_REQUEST,
	PAGE_FILE_CREATE_FAILURE,
	PAGE_FILE_CREATE_SUCCESS,
	PAGE_FILE_DELETE_REQUEST,
	PAGE_FILE_DELETE_FAILURE,
	PAGE_FILE_DELETE_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
};

export default function pages(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case PAGE_FILE_RESET_MESSAGE:
			return {
				...state,
				message: {
					type: '',
					text: '',
				},
			};

		case PAGE_FILES_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PAGE_FILES_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PAGE_FILES_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		case PAGE_FILE_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PAGE_FILE_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PAGE_FILE_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case PAGE_FILE_DELETE_REQUEST:
			return {
				...state,
				isDeleting: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PAGE_FILE_DELETE_FAILURE:
			return {
				...state,
				isDeleting: true,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PAGE_FILE_DELETE_SUCCESS:
			return {
				...state,
				isDeleting: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/pageFiles.js